// extracted by mini-css-extract-plugin
module.exports = {"container":"requirementalertlist_container__2shQs"};